"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compare = void 0;
const uom_1 = require("@genesys/uom");
const property_1 = require("@promaster-sdk/property");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const compare = (a, b) => {
    switch (a.type) {
        case "integer":
        case "text":
            return property_1.PropertyValue.defaultComparer(a, b);
        case "amount":
            if (a.type !== b.type) {
                throw new Error("Must compare same type");
            }
            return (0, uom_1.compare)(a.value, b.value);
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(a);
            throw new Error("Unkown property type");
    }
};
exports.compare = compare;
//# sourceMappingURL=property-compare.js.map